import { ReportBonuses, ReportTotals } from '../../../../../common/types/interfaces'
import classes from './Totals.module.sass'

type Props = {
  totals: ReportTotals | null
  bonuses: ReportBonuses | null
}

export const Totals = ({ totals, bonuses }: Props) => {
  return (
    <div className={classes.grid}>
      <div className={classes.item}>
        <span className={classes.label}>Заказы</span>
        <span className={classes.value}>{totals?.count ?? 0}</span>
      </div>
      <div className={classes.item}>
        <span className={classes.label}>Сумма</span>
        <span className={classes.value}>{totals?.sum ?? 0} ₽</span>
      </div>
      <div className={classes.item}>
        <span className={classes.label}>Средний чек</span>
        <span className={classes.value}>{totals?.avg ? totals.avg.toFixed(2) : 0} ₽</span>
      </div>
      <div className={classes.item}>
        <span className={classes.label}>Бонусы (списано)</span>
        <span className={classes.value}>{bonuses?.spent ?? 0}</span>
      </div>
      <div className={classes.item}>
        <span className={classes.label}>Бонусы (начислено)</span>
        <span className={classes.value}>{bonuses?.accrued ?? 0}</span>
      </div>
    </div>
  )
}
